import { createSlice } from '@reduxjs/toolkit';
import { refreshFast, refreshSlow } from './AppStore';

export const reducerName = 'authState';

const orgId = localStorage.getItem('orgId');
const apiKey = localStorage.getItem('apiKey');
const deviceId = localStorage.getItem('deviceId');

const initialState = {
    orgId: orgId || null,
    apiKey: apiKey || null,
    deviceId: deviceId || null,
};

const authSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setOrgId: (state, action) => {
            localStorage.setItem('orgId', action.payload);
            state.orgId = action.payload;
        },
        setApiKey: (state, action) => {
            localStorage.setItem('apiKey', action.payload);
            state.apiKey = action.payload;
        },
        setDeviceId: (state, action) => {
            localStorage.setItem('deviceId', action.payload);
            state.deviceId = action.payload;
        },
    },
});

export const { setOrgId, setApiKey, setDeviceId } = authSlice.actions;

export const login = () => (dispatch) => {
    dispatch(refreshFast());
    dispatch(refreshSlow());
};

export default authSlice.reducer;